import React from 'react';
import { Grid } from '@material-ui/core';

const RetrackField = ({ retrack_quota_remaining = 0, retrack_quota_total = 0, classes = {}, title = '' }) => {
    retrack_quota_remaining = retrack_quota_remaining || 0;
    retrack_quota_total = retrack_quota_total || 0;

    return (
        <Grid container item xs={12}>
            <Grid item xs={8} style={{ paddingRight: 8 }}>
                <h5 className={classes.infoText}>{title}</h5>
            </Grid>
            <Grid item xs={4}>
                <p className={`${classes.infoText} ${classes.infoTextHighlight}`}>{retrack_quota_remaining} / {retrack_quota_total}</p>
            </Grid>
        </Grid>
    );
};

export default RetrackField;
